import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { parseAsDateUTC, toISODatewithoutTimezone } from 'app/infrastructure/data/date';
import { ExternalUrlItem } from '../types-store';
import { ExternalUrlItemWire } from '../types';

export const mapExternalUrlFromWire = (wire: Partial<ExternalUrlItemWire>): ExternalUrlItem => ({
  id: wire?.code?.v,
  description: wire?.code?.d,
  disabled: wire?.disabled
    ? parseAsDateUTC(wire?.disabled)
    : undefined,
  urlTemplate: wire?.urlTemplate,
  excludeFields: wire?.exclude?.length > 0
  ? wire.exclude.map(exclude => ({
    value: exclude.v,
    description: exclude.d
  })) : [],
  language: (wire?.language?.map(codeItemToStoreValue) ?? [])
    .map(item => ({
      value: item.value,
      description: item.description
    })),
  longDescription: (wire?.language?.map(codeItemToStoreValue) ?? [])
    .map(item => ({
      value: item.value,
      description: item.longDescription
    }))
});

export const mapExternalUrlToWire = (externalUrl: ExternalUrlItem): ExternalUrlItemWire => ({
  code: { v: externalUrl?.id, d: externalUrl?.description },
  urlTemplate: externalUrl?.urlTemplate?.trim(),
  disabled: externalUrl?.disabled
    ? toISODatewithoutTimezone(externalUrl?.disabled)()
    : undefined,
  exclude: externalUrl?.excludeFields?.length > 0
    ? externalUrl.excludeFields.map(field => ({
      v: field.value
    })) : [],
  language: externalUrl?.language?.map(languageItem => {
    const longDescription = externalUrl?.longDescription?.find(longDescriptionItem =>
      longDescriptionItem.value === languageItem.value)?.description?.trim();

    return {
      v: languageItem.value,
      d: languageItem.description?.trim(),
      ...(!!longDescription && { ld: longDescription })
    };
  }) ?? []
});

